import { action, makeObservable, observable } from "mobx";
import { IPromiseBasedObservable, fromPromise } from "mobx-utils";
import {
  GetNoticeDefinitionDataDto,
  NoticeDefinitionApi,
  RenderPatientNoticeTemplateDto,
} from "../../api-client";
import AuthStore from "../Auth/authStore";
import UserStore from "../User/UserStore";
import notificationStore from "../Notification/notificationStore";
import { handleBlobError } from "../../utils/error-utils";

export default class NoticeStore {
  public apiClient: NoticeDefinitionApi;
  public userStore: UserStore; // Include UserStore as a property
  public authStore: AuthStore;

  public constructor(apiClient: NoticeDefinitionApi, userStore: UserStore, authStore: AuthStore) {
    makeObservable(this);
    this.apiClient = apiClient;
    this.userStore = userStore; // Assign the passed UserStore
    this.authStore = authStore;
  }
  public patientNoticeDataArr: GetNoticeDefinitionDataDto[] = [];
  public resourceRequest: IPromiseBasedObservable<any> | null = null;

  setPatientNoticeDataArr = (notices: GetNoticeDefinitionDataDto[]) => {
    this.patientNoticeDataArr = notices;
  };

  public fetchPatientNoticeData = async (patientId: number) => {
    try {
      const response = await this.apiClient.checkForNewNoticeData(patientId);
      const data = response.data as GetNoticeDefinitionDataDto[];
      // console.log("FETCH_NOTICE_DATA", data?.concat());

      this.setPatientNoticeDataArr(data?.length ? data : []);

      return this.patientNoticeDataArr;
    } catch (error) {
      // console.log("Error fetching patient notice data", error);
      this.resourceRequest = fromPromise.reject(error);
    }
  };

  public renderPatientNoticeTemplate = async (
    patientNoticeTempateDto: RenderPatientNoticeTemplateDto
  ) => {
    try {
      const response = await this.apiClient.renderPatientNoticeTemplate(patientNoticeTempateDto, {
        responseType: "blob",
      });

      const disposition = response.headers["content-disposition"];
      // console.log("Content Disposition", disposition);

      let fileName = "download.pdf"; // fallback

      if (disposition && disposition.indexOf("filename=") !== -1) {
        const fileNameMatch = disposition.match(/filename="(.+?)"/);
        if (fileNameMatch.length === 2) fileName = fileNameMatch[1];
      }

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: "application/pdf" });

      // Create a link to download the file
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();

      return blob;
    } catch (error: any) {
      await handleBlobError(error, (title: string, error: any) => {
        notificationStore.showMessage(title, "error", error);
      });

      this.resourceRequest = fromPromise.reject(error);
    }
  };
}
